import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=d4a5f106&"
import script from "./OrderOverview.vue?vue&type=script&lang=js&"
export * from "./OrderOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ijsedal/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4a5f106')) {
      api.createRecord('d4a5f106', component.options)
    } else {
      api.reload('d4a5f106', component.options)
    }
    module.hot.accept("./OrderOverview.vue?vue&type=template&id=d4a5f106&", function () {
      api.rerender('d4a5f106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/OrderOverview.vue"
export default component.exports